import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { requestPasswordResetLink } from '../../../redux/slices/authSlice';

//import { Link } from 'react-router-dom';
import { Container, FormContainer } from './ForgotPasswordStyles';
// import logo from '../../../assets/images/headerLogo.svg';
// import btnlogo from '../../../assets/images/btnLogo.svg';

const ForgotPassword = () => {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.auth);

  const [email, setEmail] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(requestPasswordResetLink(email));
  };

  return (
    <Container>
      <FormContainer>
      <h2>Meta<span>Click</span></h2>
        <div className='header'>
          <h1>Forgot Password?</h1>
          <p>Enter your email and we will send you reset instructions</p>
        </div>
        <form onSubmit={handleSubmit}>
          <div className='single-form'>
            <label htmlFor='email'>Email</label>
            <input
              type='email'
              placeholder='Email'
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <button type="submit" disabled={loading}>
            {loading ? 'Sending...' : 'Reset Password'}
          </button>
        </form>
      </FormContainer>

      {/* <ImgSection>
        <div>
          <img src={btnlogo} alt='' />
          <p>
            Run your ads and campaigns with DigiClick and make huge <br />
            impressions and conversions that will help your business
          </p>
        </div>
      </ImgSection> */}
    </Container>
  );
};

export default ForgotPassword;
